<template>
  <div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
      <li class="breadcrumb-item">
        <router-link to="/setting/users">{{ $t("user_list") }}</router-link>
      </li>
      <li class="breadcrumb-item active" aria-current="page">{{ $t("user_create") }}</li>
    </ol>
    <div class="x_header">
      <button
        type="button"
        class="btn btn-outline-primary btn-sm no-bor"
        @click="$router.go(-1)"
      >
        <i class="fa fa-arrow-circle-o-left"></i> {{ $t("back") }}
      </button>
      <button
        type="button"
        class="btn btn-outline-primary btn-sm no-bor"
        @click="clickSaveHandler"
      >
        <i class="fa fa-floppy-o"></i> {{ $t("save") }}
      </button>
    </div>
    <div class="x_body">
      <div class="card x_card">
        <div class="card-body">
          <div v-if="$v.$error" class="alert alert-danger x-error">
            <div class="error" v-if="!$v.model.UserName.required">
              - សូមធ្វើកាបញ្ចូលឈ្មោះ
            </div>
            <div class="error" v-if="!$v.model.PhoneNumber.required">
              - សូមធ្វើកាបញ្ចូលលេខទូរស័ព្ទ
            </div>
            <div class="error" v-if="!$v.model.Verify.sameAsPassword">
              - សូមធ្វើការពិនិត្យលេខសំងាត់ម្តងទៀត
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="flex-container">
                <div>
                  <div>
                    <input
                      type="file"
                      ref="file"
                      @change="fileChangeHandler"
                      style="display: none"
                    />
                    <img
                      :src="img"
                      alt=""
                      class="img-thumbnail"
                      style="width: 150px; height: 135px"
                      @click="$refs.file.click()"
                    />
                  </div>
                </div>
                <div class="flex-right">
                  <div
                    class="form-group"
                    :class="{ 'form-group-error': $v.model.UserName.$error }"
                  >
                    <label class="label-control blue">{{ $t("user_name") }}</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="$v.model.UserName.$model"
                    />
                  </div>
                  <div
                    class="form-group"
                    :class="{ 'form-group-error': $v.model.DisplayName.$error }"
                  >
                    <label class="label-control blue">{{ $t("display_name") }}</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="$v.model.DisplayName.$model"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2">
              <div
                class="form-group"
                :class="{ 'form-group-error': $v.model.Email.$error }"
              >
                <label class="label-control blue">{{ $t("user_email") }}</label>
                <input
                  type="email"
                  class="form-control form-control-sm"
                  v-model="$v.model.Email.$model"
                />
              </div>
            </div>
            <div class="col-sm-2">
              <div
                class="form-group"
                :class="{ 'form-group-error': $v.model.PhoneNumber.$error }"
              >
                <label class="label-control blue">{{ $t("phone") }}</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="$v.model.PhoneNumber.$model"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2">
              <div
                class="form-group"
                :class="{ 'form-group-error': $v.model.PasswordHash.$error }"
              >
                <label class="label-control blue">{{ $t("user_password") }}</label>
                <input
                  type="password"
                  class="form-control form-control-sm"
                  v-model="$v.model.PasswordHash.$model"
                />
              </div>
            </div>
            <div class="col-sm-2">
              <div
                class="form-group"
                :class="{ 'form-group-error': $v.model.Verify.$error }"
              >
                <label class="label-control blue">{{
                  $t("user_confirm_password")
                }}</label>
                <input
                  type="password"
                  class="form-control form-control-sm"
                  v-model="$v.model.Verify.$model"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2">
              <div
                class="form-group"
                :class="{ 'form-group-error': $v.model.GroupId.$error }"
              >
                <label class="label-control blue">{{ $t("user_group") }}</label>
                <select
                  class="form-control form-control-sm"
                  v-model="$v.model.GroupId.$model"
                >
                  <option v-for="ret in groups" :value="ret.Id" :key="ret.Id">
                    {{ ret.Name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, sameAs, minLength } from "vuelidate/lib/validators";

export default {
  data: function () {
    return {
      model: {
        UserName: "",
        Email: "",
        PasswordHash: "",
        Verify: "",
        PhoneNumber: "",
        DisplayName: "",
        GroupId: "",
        ClientId: this.$store.state.company.ClientId,
        ClientName: "",
      },
      img: "/img/no-image.svg",
      file: "",
      groups: [],
    };
  },
  validations: {
    model: {
      UserName: {
        required,
        minLength: minLength(6),
      },
      PasswordHash: {
        required,
        minLength: minLength(6),
      },
      Verify: {
        sameAsPassword: sameAs("PasswordHash"),
      },
      Email: { required },
      PhoneNumber: { required },
      DisplayName: { required },
      GroupId: { required },
    },
  },
  created() {
    this.listGroup();
  },
  methods: {
    clickSaveHandler: function () {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.img != "/img/no-image.svg") {
          this.model.File = this.img;
        }
        this.$api()
          .post("account/register", this.model)
          .then((res) => {
            if (this.$isValid(res)) {
              this.$router.push({ name: "user" });
            }
          });
      }
    },
    fileChangeHandler: function () {
      const file = this.$refs.file.files[0];
      const reader = new FileReader();

      reader.onloadend = () => {
        this.img = reader.result;
      };
      reader.readAsDataURL(file);
    },
    listGroup() {
      this.$api()
        .post("user/groups", {})
        .then((res) => {
          if (this.$isValid(res)) {
            this.groups = res.data.Json.Groups;
          }
        });
    },
  },
};
</script>
